(function () {
  const countdownWidgets = document.getElementsByClassName('flash-sale-countdown');

  Array.from(countdownWidgets).forEach((widget) => {
    const countdownDate = widget.getAttribute('data-countdown-date');
    const showDaysAttr = widget.getAttribute('data-use-days');
    const showDays = !!((showDaysAttr && showDaysAttr === 'true'));

    const x = setInterval(() => {
      const today = new Date();
      const todayParsed = Date.parse(today);
      const endDateTime = Date.parse(countdownDate);

      const totalDiff = endDateTime - todayParsed;
      let seconds = Math.floor((totalDiff / 1000) % 60);
      let minutes = Math.floor((totalDiff / 1000 / 60) % 60);
      const hoursCalc = totalDiff / (3600000);
      let hours = showDays ? Math.floor((hoursCalc) % 24) : Math.floor((totalDiff / (3600000)));
      let days = Math.floor(totalDiff / (3600000 * 24));

      seconds = seconds < 10 ? `0${seconds}` : seconds;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      hours = hours < 10 ? `0${hours}` : hours;

      // check if time is negative and set to zero
      seconds = seconds && seconds > 0 ? seconds : 0;
      minutes = minutes && minutes > 0 ? minutes : 0;
      hours = hours && hours > 0 ? hours : 0;
      days = days && days > 0 ? days : 0;

      const daysElems = widget.getElementsByClassName('clock-days');
      const hoursElems = widget.getElementsByClassName('clock-hours');
      const minutesElems = widget.getElementsByClassName('clock-minutes');
      const secondsElems = widget.getElementsByClassName('clock-seconds');

      if (showDays) {
        Array.from(daysElems).forEach((el) => {
          const dayEl = el;
          dayEl.innerText = days;
        });
      }
      Array.from(hoursElems).forEach((el) => {
        const hourEl = el;
        hourEl.innerText = hours;
      });
      Array.from(minutesElems).forEach((el) => {
        const minEl = el;
        minEl.innerText = minutes;
      });
      Array.from(secondsElems).forEach((el) => {
        const secEl = el;
        secEl.innerText = seconds;
      });

      // do something later when date is reached
      if (totalDiff < 0) {
        // Do something
        clearInterval(x);
      }
    }, 0);
  });
}());
